module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.opened) ? _c('div', {
    staticClass: "u-bg-overlay"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-theme-config-container",
    class: {
      'is-closed': _vm.opened
    }
  }, [_c('div', {
    staticClass: "u-theme-config-panel",
    class: {
      'open': _vm.opened
    },
    staticStyle: {
      "min-width": "800px",
      "overflow": "auto"
    }
  }, [(_vm.opened) ? _c('div', {
    staticClass: "u-theme-content"
  }, [_c('strong', [_vm._v("Informe o motivo:")]), _c('br'), _c('br'), _vm._v(" "), (_vm.newStatus === 98) ? _c('div', {
    staticClass: "w-full block no-select"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.rg),
      expression: "motivos.rg"
    }],
    attrs: {
      "id": "rg",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.rg) ? _vm._i(_vm.motivos.rg, null) > -1 : (_vm.motivos.rg)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.rg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "rg", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "rg", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "rg", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rg"
    }
  }, [_vm._v("RG OU\n                CNH"), (_vm.arrematante.pessoa.tipo === 2) ? _c('span', [_vm._v(" DO(s) SÓCIO(s)")]) : _vm._e()])]), _vm._v(" "), (_vm.motivos.rg) ? _c('div', {
    staticClass: "m-l"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.rgIlegivel),
      expression: "motivos.rgIlegivel"
    }],
    attrs: {
      "id": "rgilegivel",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.rgIlegivel) ? _vm._i(_vm.motivos.rgIlegivel, null) > -1 : (_vm.motivos.rgIlegivel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.rgIlegivel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "rgIlegivel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "rgIlegivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "rgIlegivel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rgilegivel"
    }
  }, [_vm._v("Ilegível\n                  - Rasurado, com cortes e/ou incompletos.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.rgIncorreto),
      expression: "motivos.rgIncorreto"
    }],
    attrs: {
      "id": "rgincorreto",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.rgIncorreto) ? _vm._i(_vm.motivos.rgIncorreto, null) > -1 : (_vm.motivos.rgIncorreto)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.rgIncorreto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "rgIncorreto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "rgIncorreto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "rgIncorreto", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rgincorreto"
    }
  }, [_vm._v("Incorreto\n                  - Divergente do cadastrado no site.")])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpf),
      expression: "motivos.cpf"
    }],
    attrs: {
      "id": "cpf",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpf) ? _vm._i(_vm.motivos.cpf, null) > -1 : (_vm.motivos.cpf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpf", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpf", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpf", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpf"
    }
  }, [(_vm.arrematante.pessoa.tipo === 2) ? _c('span', [_vm._v("CNPJ")]) : _c('span', [_vm._v("CPF")])])]), _vm._v(" "), (_vm.motivos.cpf) ? _c('div', {
    staticClass: "m-l"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpfIlegivel),
      expression: "motivos.cpfIlegivel"
    }],
    attrs: {
      "id": "cpfilegivel",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpfIlegivel) ? _vm._i(_vm.motivos.cpfIlegivel, null) > -1 : (_vm.motivos.cpfIlegivel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpfIlegivel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpfIlegivel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpfIlegivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpfIlegivel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpfilegivel"
    }
  }, [_vm._v("Ilegível\n                  - Rasurado, com cortes e/ou incompletos.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpfIncorreto),
      expression: "motivos.cpfIncorreto"
    }],
    attrs: {
      "id": "cpfincorreto",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpfIncorreto) ? _vm._i(_vm.motivos.cpfIncorreto, null) > -1 : (_vm.motivos.cpfIncorreto)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpfIncorreto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpfIncorreto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpfIncorreto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpfIncorreto", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpfincorreto"
    }
  }, [_vm._v("Incorreto - Divergente do cadastrado no site.")])])]) : _vm._e()]), _vm._v(" "), (_vm.arrematante.pessoa.tipo === 2) ? _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.contratoSocial),
      expression: "motivos.contratoSocial"
    }],
    attrs: {
      "id": "contratoSocial",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.contratoSocial) ? _vm._i(_vm.motivos.contratoSocial, null) > -1 : (_vm.motivos.contratoSocial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.contratoSocial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "contratoSocial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "contratoSocial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "contratoSocial", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "contratoSocial"
    }
  }, [_vm._v("CONTRATO SOCIAL")])]), _vm._v(" "), (_vm.motivos.contratoSocial) ? _c('div', {
    staticClass: "m-l"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.contratoSocialIlegivel),
      expression: "motivos.contratoSocialIlegivel"
    }],
    attrs: {
      "id": "contratoSocialilegivel",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.contratoSocialIlegivel) ? _vm._i(_vm.motivos.contratoSocialIlegivel, null) > -1 : (_vm.motivos.contratoSocialIlegivel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.contratoSocialIlegivel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "contratoSocialIlegivel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "contratoSocialIlegivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "contratoSocialIlegivel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "contratoSocialilegivel"
    }
  }, [_vm._v("Ilegível\n                  - Rasurado, com cortes e/ou incompletos.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.contratoSocialIncorreto),
      expression: "motivos.contratoSocialIncorreto"
    }],
    attrs: {
      "id": "contratoSocialincorreto",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.contratoSocialIncorreto) ? _vm._i(_vm.motivos.contratoSocialIncorreto, null) > -1 : (_vm.motivos.contratoSocialIncorreto)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.contratoSocialIncorreto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "contratoSocialIncorreto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "contratoSocialIncorreto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "contratoSocialIncorreto", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpfincorreto"
    }
  }, [_vm._v("Incorreto - Divergente do cadastrado no site.")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpres),
      expression: "motivos.cpres"
    }],
    attrs: {
      "id": "cpres",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpres) ? _vm._i(_vm.motivos.cpres, null) > -1 : (_vm.motivos.cpres)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpres,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpres", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpres", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpres", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpres"
    }
  }, [(_vm.arrematante.pessoa.tipo === 2) ? _c('span', [_vm._v("COMPROVANTE DE ENDEREÇO")]) : _c('span', [_vm._v("COMPROVANTE DE RESIDÊNCIA")]), _vm._v("\n                (Modelos: Água, Gás, Energia elétrica, IPTU ou Telefone Fixo)")])]), _vm._v(" "), (_vm.motivos.cpres) ? _c('div', {
    staticClass: "m-l"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpresIlegivel),
      expression: "motivos.cpresIlegivel"
    }],
    attrs: {
      "id": "cpresilegivel",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpresIlegivel) ? _vm._i(_vm.motivos.cpresIlegivel, null) > -1 : (_vm.motivos.cpresIlegivel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpresIlegivel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpresIlegivel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpresIlegivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpresIlegivel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpresilegivel"
    }
  }, [_vm._v("Ilegível - Rasurado, com cortes e/ou incompletos.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpresIncorreto),
      expression: "motivos.cpresIncorreto"
    }],
    attrs: {
      "id": "cpresincorreto",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpresIncorreto) ? _vm._i(_vm.motivos.cpresIncorreto, null) > -1 : (_vm.motivos.cpresIncorreto)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpresIncorreto,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpresIncorreto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpresIncorreto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpresIncorreto", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpresincorreto"
    }
  }, [_vm._v("Incorreto - Divergente do cadastrado no site.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpresEmissao90dias),
      expression: "motivos.cpresEmissao90dias"
    }],
    attrs: {
      "id": "cpresemissao",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpresEmissao90dias) ? _vm._i(_vm.motivos.cpresEmissao90dias, null) > -1 : (_vm.motivos.cpresEmissao90dias)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpresEmissao90dias,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpresEmissao90dias", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpresEmissao90dias", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpresEmissao90dias", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpresemissao"
    }
  }, [_vm._v("Emitido no prazo superior a 90 dias")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpresConjuge),
      expression: "motivos.cpresConjuge"
    }],
    attrs: {
      "id": "cpresconjuge",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpresConjuge) ? _vm._i(_vm.motivos.cpresConjuge, null) > -1 : (_vm.motivos.cpresConjuge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpresConjuge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpresConjuge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpresConjuge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpresConjuge", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpresconjuge"
    }
  }, [(_vm.arrematante.pessoa.tipo === 2) ? _c('span', [_vm._v("Em nome do(s) Sócio(s)")]) : _c('span', [_vm._v("Em nome do cônjuge - Enviar Certidão de Casamento e/ou União Estável")])])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.cpresTerceiros),
      expression: "motivos.cpresTerceiros"
    }],
    attrs: {
      "id": "cpresterceiros",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.motivos.cpresTerceiros) ? _vm._i(_vm.motivos.cpresTerceiros, null) > -1 : (_vm.motivos.cpresTerceiros)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.motivos.cpresTerceiros,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.motivos, "cpresTerceiros", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.motivos, "cpresTerceiros", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.motivos, "cpresTerceiros", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cpresterceiros"
    }
  }, [_vm._v("Em nome de terceiros - Enviar comprovação de vínculo e\n                  Declaração de residência do Detran")])])]) : _vm._e()])])]) : _vm._e(), _vm._v("\n\n        Tem certeza que deseja alterar o status?"), _c('br'), _c('br'), _vm._v("\n\n        De "), _c('span', {
    staticClass: "label text-sm",
    class: 'bg-' + _vm.getStatus[_vm.oldStatus].class
  }, [_vm._v(_vm._s(_vm.getStatus[_vm.oldStatus].titulo))]), _vm._v("\n        para "), _c('span', {
    staticClass: "label text-sm",
    class: 'bg-' + _vm.getStatus[_vm.newStatus].class
  }, [_vm._v(_vm._s(_vm.getStatus[_vm.newStatus].titulo))]), _vm._v(" "), _c('p', {
    staticClass: "m-t-xl"
  }, [_c('button', {
    ref: "btn",
    staticClass: "btn btn-success",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8c6b982","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/ConfirmStatusAprovacao.vue
// module id = 873
// module chunks = 2